import React, { useEffect, useState } from "react";
import MenuIcon from "@material-ui/icons/Menu";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import { IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import "../../assets/css/drawer.css";
import { Link, animateScroll as scroll } from "react-scroll";

const useStyles = makeStyles({
  listStyle: {
    width: "auto",
    textAlign: "right",
  },
  iconColor: {
    color: "#fff",
  },
  iconColorBlack: {
    color: "#404040",
  },
});

const DrawerMenu = () => {
  const [isHeightOver, setIsHeightOver] = useState(false);

  useEffect(() => {
    const scrollAction = () => {
      if (320 > window.scrollY) {
        setIsHeightOver(true);
      } else {
        setIsHeightOver(false);
      }
    };
    window.addEventListener("scroll", scrollAction, {
      capture: false,
      passive: true,
    });
    scrollAction();
  }, []);

  const classes = useStyles();

  const [open, setOpen] = useState(false);
  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const scrollToTop = () => {
    scroll.scrollToTop();
  };

  const list = () => (
    <div
      className={classes.listStyle}
      role="presentation"
      //   onClick={toggleDrawer(false)}
      //   onKeyDown={toggleDrawer(false)}
    >
      <List>
        <div className="drawer-cancel-btn hover1">
          <IconButton
            aria-label="delete"
            color="default"
            onClick={() => {
              handleDrawerClose();
            }}
          >
            <CloseIcon style={{ fontSize: 25 }} />
          </IconButton>
        </div>
        <Divider />

        <div
          className="drawer-list hover1"
          onClick={() => {
            scrollToTop();
          }}
        >
          TOP
        </div>
        <Divider />
        <Link to="about" spy={true} smooth={true} offset={-70} duration={500}>
          <div className="drawer-list hover1">概要</div>
        </Link>
        <Divider />
        <Link to="merit" spy={true} smooth={true} offset={-70} duration={500}>
          <div className="drawer-list hover1">メリット</div>
        </Link>
        <Divider />
        <Link to="contact" spy={true} smooth={true} offset={-70} duration={500}>
          <div className="drawer-list hover1">お問い合わせ</div>
        </Link>
      </List>
    </div>
  );

  return (
    <div>
      <div className="drawer-adjust--icon hover1">
        <IconButton
          aria-label="delete"
          color="default"
          onClick={() => {
            handleDrawerOpen();
          }}
        >
          <MenuIcon
            className={
              isHeightOver ? classes.iconColor : classes.iconColorBlack
            }
            style={{ fontSize: 25 }}
          />
        </IconButton>
      </div>
      <Drawer anchor="top" open={open}>
        {list()}
      </Drawer>
    </div>
  );
};
export default DrawerMenu;
